import { NetworkConstants } from "./network.constants";
import { DependencyPersonToEventInvitation } from "./person.data";
import { DependencyHuntingDistrictToEventInvitation } from './hunting-district.dto'
import { DependencyEventToEventInvitation } from "./event.data";
import { WhereFilterOp } from 'firebase/firestore'
import { DependencyEventInvitationToEvent, DependencyEventInvitationToHuntingDistrict, DependencyEventInvitationToPerson } from "./event-invitation.data";

export const enum ConditionType {
    ATTR_EQUALITY = 0, DATE_GREATER_OR_EQUAL = 1
}

export interface IFirebaseUpdateCondition {
    conditionType: ConditionType
    attribute: string,
    condition: WhereFilterOp,
    value?: any
    attributeOfOrigin?: any
}

export interface IDependencyMapping {
    collectionName: string
    mapping: Map<string, string>,
    getQuery: (firestore: any, origin: any, now: Date|null) => any
    getDoc: (firestore: any, identifier: string) => any,
    mappingIdentifier?: string
    // conditions: IFirebaseUpdateCondition[]
}

/**
 * Central location for configuring the dependencies between collections
 */
export const DBDependenciesOneToMany = new Map<string, Map<string, IDependencyMapping>>([
    [
        NetworkConstants.COLLECTION_PERSON, new Map([
            // all dependencies from Person -> [Collection]
            [NetworkConstants.COLLECTION_EVENT_INV, DependencyPersonToEventInvitation],
        ]),
    ],
    [
        // all dependencies from HuntingDistrict -> [Collection]
        NetworkConstants.COLLECTION_HUNTING_DISTRICT, new Map([
            [NetworkConstants.COLLECTION_EVENT_INV, DependencyHuntingDistrictToEventInvitation],
        ])
    ],
    [
        NetworkConstants.COLLECTION_EVENT, new Map([
            // all dependencies from Event -> [Collection]
            [NetworkConstants.COLLECTION_EVENT_INV, DependencyEventToEventInvitation],
        ])
    ]
])

export const DBDependenciesManyToOne = new Map<string, Map<string, IDependencyMapping>>([
    [
        NetworkConstants.COLLECTION_EVENT_INV, new Map([
            [NetworkConstants.COLLECTION_PERSON, DependencyEventInvitationToPerson],
            [NetworkConstants.COLLECTION_EVENT, DependencyEventInvitationToEvent],
            [NetworkConstants.COLLECTION_HUNTING_DISTRICT, DependencyEventInvitationToHuntingDistrict]
        ])
    ],
])